/* --- Dawn fence for our footer controls (prevents native listeners) --- */
(function fenceDawnForBundleFooter() {
    document.addEventListener('click', function (e) {
        const footer = e.target.closest('.fw-bundle-footer-row');
        if (!footer) return;

        const isQtyBtn = e.target.closest('button[name="plus"], button[name="minus"]');
        const isRemove = e.target.closest('[data-bundle-remove], [data-fw-bundle-remove]');
        if (!(isQtyBtn || isRemove)) return;

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        const evt = new CustomEvent('fw:footer:click', {
            bubbles: true,
            cancelable: true,
            detail: { originalEvent: e }
        });
        (e.target || footer).dispatchEvent(evt);
    }, true);

    document.addEventListener('change', function (e) {
        const input = e.target.closest('.fw-bundle-footer-row input[type="number"][data-bundle-qty-input], .fw-bundle-footer-row input[type="number"][data-fw-bundle-input]');
        if (!input) return;

        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        const evt = new CustomEvent('fw:footer:change', {
            bubbles: true,
            cancelable: true,
            detail: { originalEvent: e }
        });
        input.dispatchEvent(evt);
    }, true);
})();

/* -----------------------------------------------------------
   Freshwater BYOB builder (vanilla JS; no HTML/CSS injection)
   ----------------------------------------------------------- */
(function () {
    const fw = {
        log: (...a) => console.log("🔹 %cFreshwater", "background:#e0e8ff;color:#2a52c9;font-weight:bold;padding:2px;", ...a),
        warn: (...a) => console.warn("🔹 %cFreshwater", "background:#e0e8ff;color:#2a52c9;font-weight:bold;padding:2px;", ...a),
        error: (...a) => console.error("🔹 %cFreshwater", "background:#e0e8ff;color:#2a52c9;font-weight:bold;padding:2px;", ...a),
    };

    /* gift box variant always added with each BYOB bundle */
    const FW_GIFT_BOX_VARIANT_ID = 45597132095638;

    const root = document.getElementById('fresh-bundle-builder');
    if (!root) {
        fw.warn('bundle root not found');
        return;
    }

    const allowDuplicates = (root.dataset.allowDuplicates || 'true') === 'true';

    let VARIANTS = [];
    let SKU_BY_VARIANT = {};
    try {
        VARIANTS = JSON.parse(document.getElementById('fresh-bundle-data').textContent).items;
        SKU_BY_VARIANT = VARIANTS.reduce((acc, v) => {
            acc[String(v.variant_id)] = v.sku || '';
            return acc;
        }, {});
    } catch (e) {
        fw.error('failed to parse bundle data', e);
        return;
    }

    if (!Array.isArray(VARIANTS) || VARIANTS.length === 0) return;

    const money = (c) => (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(c)
        : `$${(c / 100).toFixed(2)}`;

    const byTitle = (a, b) =>
        a.product_title.localeCompare(b.product_title) ||
        a.variant_title.localeCompare(b.variant_title);

    const state = { pick1: null, pick2: null, pick3: null };

    const $ = (sel) => root.querySelector(sel);
    const $sel1 = $('[data-select="1"]');
    const $sel2 = $('[data-select="2"]');
    const $sel3 = $('[data-select="3"]');
    const $pre1 = $('[data-preview="1"]');
    const $pre2 = $('[data-preview="2"]');
    const $pre3 = $('[data-preview="3"]');
    const $add  = $('[data-add]');
    const $total= root.querySelector('[data-total]');
    const $note = root.querySelector('[data-note]');

    /* ---------- next “Gift Box N” helpers ---------- */

    function extractNumbersFromBundleId(str) {
        if (!str) return null;
        const m = String(str).match(/gift[-\s]?box[-\s]?(\d+)/i);
        return m ? parseInt(m[1], 10) : null;
    }

    async function fetchCart() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
    }

    function maxGiftBoxFromCartItems(cart) {
        const nums = (cart.items || [])
            .map(li => li.properties && (li.properties['Bundle ID'] || li.properties['bundle_id']) || null)
            .map(extractNumbersFromBundleId)
            .filter(n => Number.isInteger(n));
        return nums.length ? Math.max(...nums) : 0;
    }

    function maxGiftBoxFromAttribute(cart) {
        try {
            const arr = cart.attributes && cart.attributes.bundles
                ? JSON.parse(cart.attributes.bundles)
                : [];
            const nums = arr
                .map(b => (b && (b.id || b['Bundle ID'])) || null)
                .map(extractNumbersFromBundleId)
                .filter(n => Number.isInteger(n));
            return nums.length ? Math.max(...nums) : 0;
        } catch {
            return 0;
        }
    }

    let freshNextBundleNum = null;

    async function initNextBundleNum(forceReload = false) {
        if (freshNextBundleNum !== null && !forceReload) return freshNextBundleNum;

        let maxNum = 0;
        try {
            const cart = await fetchCart();
            maxNum = Math.max(maxGiftBoxFromCartItems(cart), maxGiftBoxFromAttribute(cart));
        } catch {
            maxNum = 0;
        }

        if (window.freshBundleCount && Number.isInteger(window.freshBundleCount)) {
            freshNextBundleNum = Math.max(maxNum, window.freshBundleCount) + 1;
        } else {
            freshNextBundleNum = maxNum + 1;
        }
        return freshNextBundleNum;
    }

    async function upsertBundleOrderAttribute(bundleId, variantIds) {
        const cart = await fetchCart();
        let current = [];
        try {
            current = cart.attributes && cart.attributes.bundles
                ? JSON.parse(cart.attributes.bundles)
                : [];
        } catch {}

        /* de-dupe by id if user spams add */
        current = current.filter(b => (b && (b.id || b['Bundle ID'])) !== bundleId);

        current.push({
            id: bundleId,
            name: root.dataset.collectionTitle || 'Bundle',
            created_at: new Date().toISOString(),
            lines: variantIds.map((vId, idx) => ({
                choice: idx + 1,
                variant_id: String(vId)
            }))
        });

        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    bundles: JSON.stringify(current)
                }
            })
        });
    }

    async function removeBundleFromAttribute(bundleId) {
        try {
            const cart = await fetchCart();
            let current = [];
            try {
                current = cart.attributes && cart.attributes.bundles
                    ? JSON.parse(cart.attributes.bundles)
                    : [];
            } catch {}
            const next = current.filter(
                b => (b && (b.id || b['Bundle ID'])) !== bundleId
            );
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        bundles: JSON.stringify(next)
                    }
                })
            });
        } catch {
            /* ignore */
        }
    }

    /* ---------- UI helpers ---------- */

    function renderOptions(select, pool, placeholder) {
        const options = [`<option value="">${placeholder}</option>`]
            .concat(
                pool.sort(byTitle).map(v => {
                    const text = `${v.product_title}`;
                    return `<option value="${v.variant_id}" data-price="${v.price}" data-img="${v.image}">${text}</option>`;
                })
            );
        select.innerHTML = options.join('');
    }

    function setPreview(el, variantId) {
        const v = VARIANTS.find(x => String(x.variant_id) === String(variantId));
        el.innerHTML = v ? `<img alt="" src="${v.image}">` : '';
    }

    function selectedIds() {
        return [state.pick1, state.pick2, state.pick3]
            .filter(Boolean)
            .map(String);
    }

    function computePool(excludeIds = []) {
        return VARIANTS.filter(v => {
            const id = String(v.variant_id);
            if (id === String(FW_GIFT_BOX_VARIANT_ID)) return false; /* never show gift box as a pick */
            return allowDuplicates ? true : !excludeIds.includes(id);
        });
    }

    function updatePrice() {
        const giftBoxVariant = VARIANTS.find(
            x => String(x.variant_id) === String(FW_GIFT_BOX_VARIANT_ID)
        );
        const giftBoxPrice = giftBoxVariant ? giftBoxVariant.price : 0;

        const sum = selectedIds().reduce((acc, id) => {
            const v = VARIANTS.find(x => String(x.variant_id) === String(id));
            return acc + (v ? v.price : 0);
        }, giftBoxPrice);

        $total.textContent = selectedIds().length
            ? `Total: ${money(sum)}`
            : `Total: ${money(giftBoxPrice)}`;
    }

    /* init first select + price */
    renderOptions($sel1, computePool([]), 'Select first');
    updatePrice();

    $sel1.addEventListener('change', () => {
        state.pick1 = $sel1.value || null;
        setPreview($pre1, state.pick1);
        updatePrice();

        if (state.pick1) {
            renderOptions($sel2, computePool([state.pick1]), 'Select second');
            $sel2.disabled = false;
        } else {
            $sel2.disabled = true;
            $sel2.value = '';
            $sel3.disabled = true;
            $sel3.value = '';
            state.pick2 = null;
            state.pick3 = null;
            setPreview($pre2, null);
            setPreview($pre3, null);
        }
        $add.disabled = !(state.pick1 && state.pick2 && state.pick3);
    });

    $sel2.addEventListener('change', () => {
        state.pick2 = $sel2.value || null;
        setPreview($pre2, state.pick2);
        updatePrice();

        if (state.pick2) {
            const exclude = allowDuplicates
                ? []
                : [state.pick1, state.pick2].filter(Boolean).map(String);
            renderOptions($sel3, computePool(exclude), 'Select third');
            $sel3.disabled = false;
        } else {
            $sel3.disabled = true;
            $sel3.value = '';
            state.pick3 = null;
            setPreview($pre3, null);
        }
        $add.disabled = !(state.pick1 && state.pick2 && state.pick3);
    });

    $sel3.addEventListener('change', () => {
        state.pick3 = $sel3.value || null;
        setPreview($pre3, state.pick3);
        updatePrice();
        $add.disabled = !(state.pick1 && state.pick2 && state.pick3);
    });

    /* ---------- Add bundle ---------- */

    async function addBundle() {
        const ids = selectedIds();
        if (ids.length !== 3) return;

        /* get a fresh unique "Gift Box N" */
        const nextNum = await initNextBundleNum(true);
        const bundleId = `Gift Box ${nextNum}`;

        const items = ids.map((id, idx) => ({
            id,
            quantity: 1,
            properties: {
                "Bundle": root.dataset.collectionTitle || "Build Your Own Gift Box",
                "Bundle ID": bundleId,
                "Choice": String(idx + 1),
                "Product SKU": SKU_BY_VARIANT[String(id)] || ""
            }
        }));

        /* auto-add the physical gift box variant itself */
        items.push({
            id: FW_GIFT_BOX_VARIANT_ID,
            quantity: 1,
            properties: {
                "Bundle": root.dataset.collectionTitle || "Build Your Own Gift Box",
                "Bundle ID": bundleId,
                "Choice": ""
            }
        });

        $add.disabled = true;
        const btnText = root.dataset.buttonText || 'Add Bundle to Cart';
        $add.textContent = 'Adding…';
        $note.textContent = '';

        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ items })
            });
            if (!res.ok) throw new Error(`status ${res.status}`);
            await res.json();

            await upsertBundleOrderAttribute(bundleId, ids);

            /* refresh Dawn cart UI and open drawer */
            await fwRefreshCartUI(true);

            /* advance our internal counter */
            window.freshBundleCount = Math.max(window.freshBundleCount || 0, nextNum);
            freshNextBundleNum = null;

            document.dispatchEvent(new CustomEvent('fresh:bundle:added', {
                detail: { bundleId, items: ids }
            }));
            $add.textContent = 'Added!';
        } catch (err) {
            fw.error('failed to add bundle', err);
            $note.textContent = 'Sorry—couldn’t add your bundle. Please try again.';
            $add.textContent = btnText;
            $add.disabled = false;
        }
    }

    $add.addEventListener('click', addBundle);

    /* expose for other code (optional) */
    window.__freshBundleBuilder = {
        initNextBundleNum,
        upsertBundleOrderAttribute,
        removeBundleFromAttribute
    };
})();

/* -----------------------------------------------------------
   Freshwater – Bundle Footer Controls (Dawn-safe, delegated)
   ----------------------------------------------------------- */
(function () {
    const $all = (sel, root = document) => Array.from(root.querySelectorAll(sel));
    const cssEsc = (s) => (window.CSS && CSS.escape)
        ? CSS.escape(s)
        : String(s).replace(/"/g, '\\"');
    
    // Track pending updates to prevent duplicate calls
    const pendingUpdates = new Map();
    const lastUpdateTime = new Map();
    const DEBOUNCE_MS = 300; // Minimum time between updates

    function disableBundleControls(bundleId, disabled) {
        const footer = document.querySelector(`.fw-bundle-footer-row[data-bundle-id="${cssEsc(bundleId)}"]`);
        if (!footer) return;
        
        const buttons = footer.querySelectorAll('.fw-qty-inc, .fw-qty-dec');
        const input = footer.querySelector('.fw-qty-input');
        
        buttons.forEach(btn => {
            btn.disabled = disabled;
            if (disabled) {
                btn.style.opacity = '0.5';
                btn.style.cursor = 'not-allowed';
            } else {
                btn.style.opacity = '';
                btn.style.cursor = '';
            }
        });
        
        if (input) {
            input.disabled = disabled;
        }
    }

    document.addEventListener('click', (e) => {
        const inc = e.target.closest('.fw-qty-inc');
        const dec = e.target.closest('.fw-qty-dec');
        const rm  = e.target.closest('.fw-bundle-remove');

        if (inc) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            
            const id = inc.dataset.bundleId;
            const input = findInput(id);
            if (!input) return;
            
            // Prevent if button is disabled or update is pending
            if (inc.disabled || pendingUpdates.has(id)) {
                return;
            }
            
            // Debounce: prevent rapid clicks
            const now = Date.now();
            const lastTime = lastUpdateTime.get(id) || 0;
            if (now - lastTime < DEBOUNCE_MS) {
                return;
            }
            
            // Get current value and ensure we only increment by 1
            const current = parseInt(input.value || '1', 10) || 1;
            const next = clamp(current + 1);
            
            // Safety check: ensure we're only incrementing by 1
            if (next !== current + 1) {
                console.warn('Bundle quantity increment safety check failed', { current, next, id });
                return;
            }
            
            // Disable controls during update
            disableBundleControls(id, true);
            input.value = next;
            lastUpdateTime.set(id, now);
            
            // Mark as pending and update
            pendingUpdates.set(id, true);
            setBundleQuantity(id, next).finally(() => {
                pendingUpdates.delete(id);
                disableBundleControls(id, false);
            });
        }

        if (dec) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            
            const id = dec.dataset.bundleId;
            const input = findInput(id);
            if (!input) return;
            
            // Prevent if button is disabled or update is pending
            if (dec.disabled || pendingUpdates.has(id)) {
                return;
            }
            
            // Debounce: prevent rapid clicks
            const now = Date.now();
            const lastTime = lastUpdateTime.get(id) || 0;
            if (now - lastTime < DEBOUNCE_MS) {
                return;
            }
            
            // Get current value and ensure we only decrement by 1
            const current = parseInt(input.value || '1', 10) || 1;

            // At qty=1, decrement removes the entire bundle
            if (current <= 1) {
                disableBundleControls(id, true);
                lastUpdateTime.set(id, now);
                pendingUpdates.set(id, true);
                removeBundle(id).finally(() => {
                    pendingUpdates.delete(id);
                    disableBundleControls(id, false);
                });
                return;
            }

            const next = clamp(current - 1);

            // Safety check: ensure we're only decrementing by 1
            if (next !== Math.max(1, current - 1)) {
                console.warn('Bundle quantity decrement safety check failed', { current, next, id });
                return;
            }

            // Disable controls during update
            disableBundleControls(id, true);
            input.value = next;
            lastUpdateTime.set(id, now);

            // Mark as pending and update
            pendingUpdates.set(id, true);
            setBundleQuantity(id, next).finally(() => {
                pendingUpdates.delete(id);
                disableBundleControls(id, false);
            });
        }

        if (rm) {
            e.preventDefault();
            removeBundle(rm.dataset.bundleId);
        }
    });

    document.addEventListener('change', (e) => {
        const input = e.target.closest('.fw-qty-input');
        if (!input) return;
        
        // Prevent if input is disabled or update is pending
        if (input.disabled || pendingUpdates.has(input.dataset.bundleId)) {
            return;
        }
        
        const id = input.dataset.bundleId;
        
        // Debounce: prevent rapid changes
        const now = Date.now();
        const lastTime = lastUpdateTime.get(id) || 0;
        if (now - lastTime < DEBOUNCE_MS) {
            // Restore previous value if change was too rapid
            const footer = document.querySelector(`.fw-bundle-footer-row[data-bundle-id="${cssEsc(id)}"]`);
            if (footer) {
                const first = document.querySelector(`.fw-bundle-child[data-bundle-id="${cssEsc(id)}"]`);
                if (first) {
                    const q = parseInt(first.getAttribute('data-qty') || '1', 10) || 1;
                    input.value = q;
                }
            }
            return;
        }
        
        const current = parseInt(input.value || '1', 10) || 1;
        const next = clamp(current);
        
        // Safety check: ensure change is reasonable (within ±1 of current)
        const first = document.querySelector(`.fw-bundle-child[data-bundle-id="${cssEsc(id)}"]`);
        if (first) {
            const actualQty = parseInt(first.getAttribute('data-qty') || '1', 10) || 1;
            const diff = Math.abs(next - actualQty);
            if (diff > 1) {
                console.warn('Bundle quantity change safety check failed', { actualQty, next, diff, id });
                // Restore to actual quantity
                input.value = actualQty;
                return;
            }
        }
        
        // Disable controls during update
        disableBundleControls(id, true);
        input.value = next;
        lastUpdateTime.set(id, now);
        
        // Mark as pending and update
        pendingUpdates.set(id, true);
        setBundleQuantity(id, next).finally(() => {
            pendingUpdates.delete(id);
            disableBundleControls(id, false);
        });
    });

    function findInput(bundleId) {
        return document.querySelector(
            `.fw-bundle-footer-row[data-bundle-id="${cssEsc(bundleId)}"] .fw-qty-input`
        );
    }

    function getBundleChildRows(bundleId) {
        return $all(`.fw-bundle-child[data-bundle-id="${cssEsc(bundleId)}"]`);
    }

    function clamp(n) {
        return Math.max(1, n);
    }

    function syncFooterQty(bundleId) {
        const input = findInput(bundleId);
        if (!input) return;
        const first = document.querySelector(`.fw-bundle-child[data-bundle-id="${cssEsc(bundleId)}"]`);
        if (!first) return;
        const q = parseInt(first.getAttribute('data-qty') || '1', 10) || 1;
        input.value = q;
    }

    async function setBundleQuantity(bundleId, qty) {
        const rows = getBundleChildRows(bundleId);
        if (!rows.length) return;

        try {
            // Validate quantity is reasonable
            if (qty < 1 || qty > 100) {
                console.error('Invalid bundle quantity', { bundleId, qty });
                throw new Error('Invalid quantity');
            }
            
            // Collect all unique line keys to avoid duplicates
            const updates = {};
            const seenKeys = new Set();
            
            for (const row of rows) {
                const key = row.dataset.lineKey;
                if (!key || seenKeys.has(key)) continue;
                seenKeys.add(key);
                updates[key] = qty;
            }

            if (Object.keys(updates).length === 0) {
                console.warn('No bundle items found to update', { bundleId });
                return;
            }

            // Log update for debugging
            console.log('🔹 %cFreshwater', 'background:#e0e8ff;color:#2a52c9;font-weight:bold;padding:2px;', 
                'Bundle quantity update', { bundleId, qty, itemCount: Object.keys(updates).length });

            // Update all items in one atomic operation
            const res = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ updates })
            });

            if (!res.ok) {
                const errorText = await res.text();
                console.error('Cart update failed', { status: res.status, error: errorText });
                throw new Error(`update failed: ${res.status}`);
            }
            
            const result = await res.json();
            
            // Verify the update was successful
            if (result && result.items) {
                const bundleItems = result.items.filter(item => {
                    const bid = (item.properties && (item.properties['Bundle ID'] || item.properties['bundle_id'])) || '';
                    return String(bid) === String(bundleId);
                });
                
                // Check if all items have the correct quantity
                const allCorrect = bundleItems.every(item => item.quantity === qty);
                if (!allCorrect && bundleItems.length > 0) {
                    console.warn('Bundle quantity mismatch after update', {
                        bundleId,
                        expected: qty,
                        actual: bundleItems.map(i => i.quantity)
                    });
                }
            }

            await refreshCartSections();
            syncFooterQty(bundleId);
        } catch (err) {
            console.error('setBundleQuantity failed', err);
            // Re-enable controls on error
            disableBundleControls(bundleId, false);
            location.reload();
        }
    }

    async function removeBundle(bundleId) {
        const rows = getBundleChildRows(bundleId);
        if (!rows.length) return;

        try {
            for (const row of rows) {
                const key = row.dataset.lineKey;
                if (!key) continue;
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ id: key, quantity: 0 })
                }).then(r => {
                    if (!r.ok) throw new Error('remove failed');
                    return r.json();
                });
            }

            /* keep cart.attributes.bundles in sync for bundleId counter */
            await window.__freshBundleBuilder?.removeBundleFromAttribute(bundleId);

            if (window.freshBundleCount) window.freshBundleCount = null;

            await refreshCartSections();
        } catch (err) {
            console.error('removeBundle failed', err);
            location.reload();
        }
    }

    async function refreshCartSections() {
        const res = await fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`Sections fetch failed: ${res.status}`);
        const json = await res.json();

        /* Update cart icon bubble inner content.
           #cart-icon-bubble is the <a> anchor in the header section — we must NOT
           replace it (that would destroy the element CartDrawer binds its click
           handler to). The cart-icon-bubble section renders only the inner content
           (SVG + count badge), so we update innerHTML of the anchor only. */
        const bubbleHost = document.querySelector('#cart-icon-bubble');
        if (bubbleHost && json['cart-icon-bubble']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = json['cart-icon-bubble'];
            const sectionEl = tmp.firstElementChild;
            if (sectionEl) bubbleHost.innerHTML = sectionEl.innerHTML;
        }

        /* Update cart drawer IN-PLACE rather than replacing the element.
           Replacing <cart-drawer> stales ProductForm.this.cart (captured at
           page-load), causing subsequent add-to-cart renderContents() calls to
           invoke open() on the detached old element so the drawer never re-opens.
           Updating in-place also avoids needing to re-bind all constructor listeners. */
        const drawerHost = document.querySelector('cart-drawer');
        if (drawerHost && json['cart-drawer']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = json['cart-drawer'];
            const nextDrawer = tmp.querySelector('cart-drawer');
            if (nextDrawer) {
                /* Sync is-empty class so CSS layout matches cart state */
                drawerHost.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));

                /* Swap #CartDrawer inner content */
                const nextInner = nextDrawer.querySelector('#CartDrawer');
                const currentInner = drawerHost.querySelector('#CartDrawer');
                if (nextInner && currentInner) {
                    currentInner.innerHTML = nextInner.innerHTML;
                    /* Re-bind overlay close handler — lost when innerHTML was replaced */
                    const overlay = drawerHost.querySelector('#CartDrawer-Overlay');
                    if (overlay) overlay.addEventListener('click', drawerHost.close.bind(drawerHost));
                }
            }
        }

        document.body.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    /* expose for debugging */
    window.__fwBundle = { setBundleQuantity, removeBundle, refreshCartSections };
})();

/* -----------------------------------------------------------
   Freshwater – global cart UI refresh helper
   ----------------------------------------------------------- */
async function fwRefreshCartUI(openDrawer = true) {
    try {
        const sections = ['cart-drawer', 'cart-icon-bubble'];
        const res = await fetch(`/?sections=${sections.join(',')}`, {
            credentials: 'same-origin'
        });
        if (!res.ok) throw new Error('Sections fetch failed');
        const htmlBySection = await res.json();

        /* replace cart icon bubble */
        const bubbleHost = document.querySelector('cart-icon-bubble');
        if (bubbleHost && htmlBySection['cart-icon-bubble']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = htmlBySection['cart-icon-bubble'];
            const next = tmp.querySelector('cart-icon-bubble') || tmp.firstElementChild;
            if (next) bubbleHost.replaceWith(next);
        }

        /* replace cart drawer */
        const drawerHost = document.querySelector('cart-drawer');
        if (drawerHost && htmlBySection['cart-drawer']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = htmlBySection['cart-drawer'];
            const next = tmp.querySelector('cart-drawer') || tmp.firstElementChild;
            if (next) drawerHost.replaceWith(next);
        }

        /* tell Dawn to rebind internals */
        document.body.dispatchEvent(new CustomEvent('cart:refresh'));
        if (openDrawer) document.querySelector('cart-drawer')?.open?.();
    } catch (e) {
        location.reload();
    }
}

/* 🔹 Freshwater — qty adjust on NON-bundle lines
   This fixes the bug you reported:
   - If a bundle is in the cart, Dawn's native +/- can get blocked / mis-synced.
   - We intercept clicks on the default Dawn qty buttons for NON-bundle rows,
     compute the new qty, POST /cart/change.js with that row's line key,
     then refresh sections.
*/
document.addEventListener('click', async function (e) {
    /* look for Dawn's default plus/minus */
    const btn = e.target.closest('button[name="plus"], button[name="minus"]');
    if (!btn) return;

    /* ignore clicks that belong to our bundle footer row */
    if (btn.closest('.fw-bundle-footer-row')) return;

    /* find the line item row */
    const row = btn.closest('.cart-item');
    if (!row) return;

    /* if it's part of a bundle child, skip (bundle footer controls that qty) */
    if (row.dataset && row.dataset.bundleId) return;

    /* non-bundle line item: proceed */
    const key = row.dataset && row.dataset.lineKey;
    if (!key) return;

    /* find the numeric input for this row */
    const qtyInput = row.querySelector('input[type="number"]');
    if (!qtyInput) return;

    /* figure out new quantity; allow 0 so minus at qty=1 removes the item */
    const currentVal = parseInt(qtyInput.value || '1', 10) || 1;
    const isPlus = btn.getAttribute('name') === 'plus';
    let nextQty = isPlus ? currentVal + 1 : currentVal - 1;
    if (nextQty < 0) nextQty = 0;

    /* stop Dawn from doing its own thing */
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    console.log(
        "🔹 %cFreshwater",
        "background:#e0e8ff; color:#2a52c9; font-weight:bold; padding:2px;",
        "non-bundle qty click → updating",
        { key, currentVal, nextQty }
    );

    /* disable buttons and show spinner while update is in-flight */
    const qtyBtns = row.querySelectorAll('button[name="plus"], button[name="minus"]');
    const spinners = row.querySelectorAll('.loading__spinner');
    qtyBtns.forEach(b => { b.disabled = true; });
    spinners.forEach(s => s.classList.remove('hidden'));

    try {
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: key, quantity: nextQty })
        });

        if (!res.ok) {
            console.error(
                "🔹 %cFreshwater",
                "background:#e0e8ff; color:#2a52c9; font-weight:bold; padding:2px;",
                "non-bundle qty update failed", res.status
            );
            location.reload();
            return;
        }

        /* re-render cart drawer + bubble so UI matches new qty */
        if (typeof window.__fwBundle?.refreshCartSections === 'function') {
            await window.__fwBundle.refreshCartSections();
        } else {
            await fwRefreshCartUI(false);
        }
    } catch (err) {
        console.error(
            "🔹 %cFreshwater",
            "background:#e0e8ff; color:#2a52c9; font-weight:bold; padding:2px;",
            "non-bundle qty update threw", err
        );
        location.reload();
    } finally {
        /* re-enable in case the section refresh failed and the row is still in DOM */
        qtyBtns.forEach(b => { b.disabled = false; });
        spinners.forEach(s => s.classList.add('hidden'));
    }
}, true);

/* 🔹 Freshwater — Cart Upsell Widget
   Handles "Add to Cart" from upsell carousel and initializes Slick
*/
(function() {
    let initTimeout = null;
    let isInitializing = false;
    
    // Truncate upsell product names to 25 characters
    function truncateUpsellNames() {
        const names = document.querySelectorAll('.cart-drawer__upsell-name');
        names.forEach(function(nameEl) {
            const text = nameEl.textContent.trim();
            if (text.length > 25) {
                nameEl.textContent = text.substring(0, 25) + '...';
            }
        });
    }
    
    function initUpsellCarousel(force = false) {
        const carousel = document.querySelector('.cart-drawer__upsell-carousel');
        if (!carousel) return;
        
        // Check if there are any slides to show first
        const slides = carousel.querySelectorAll('.cart-drawer__upsell-item');
        if (slides.length === 0) return;
        
        // If already initialized and working correctly, skip unless forced
        if (!force && typeof $0 !== 'undefined' && $0(carousel).hasClass('slick-initialized')) {
            const slickSlides = $0(carousel).find('.slick-slide:not(.slick-cloned)');
            const originalSlides = carousel.querySelectorAll('.cart-drawer__upsell-item');
            // If Slick has all slides, don't reinitialize
            if (slickSlides.length === originalSlides.length && originalSlides.length > 0) {
                return;
            }
        }
        
        // Prevent multiple simultaneous initializations
        if (isInitializing) return;
        isInitializing = true;
        
        // Destroy existing Slick instance if it exists
        if (typeof $0 !== 'undefined' && $0(carousel).hasClass('slick-initialized')) {
            carousel.classList.remove('slick-arrows-ready');
            $0(carousel).slick('unslick');
            // Small delay to ensure unslick completes
            setTimeout(function() {
                isInitializing = false;
                initUpsellCarousel(true);
            }, 100);
            return;
        }
        
        // Get settings from data-slick attribute
        const slickData = carousel.getAttribute('data-slick');
        if (!slickData) return;
        
        try {
            const slickSettings = JSON.parse(slickData.replace(/&quot;/g, '"'));
            
            // Initialize Slick directly with our settings
            if (typeof $0 !== 'undefined') {
                // Show all slides temporarily so Slick can detect them
                slides.forEach(function(slide) {
                    slide.style.display = '';
                });
                
                // Wait a frame to ensure slides are visible
                requestAnimationFrame(function() {
                    if (!carousel.parentNode) return;
                    
                    // Verify slides are still there
                    const currentSlides = carousel.querySelectorAll('.cart-drawer__upsell-item');
                    if (currentSlides.length === 0) return;
                    
                    // Initialize Slick - it should now detect all visible slides
                    $0(carousel).slick(slickSettings);
                    
                    // After initialization, verify all slides were detected
                    setTimeout(function() {
                        if ($0(carousel).hasClass('slick-initialized')) {
                            const slickSlides = $0(carousel).find('.slick-slide:not(.slick-cloned)');
                            const originalSlides = carousel.querySelectorAll('.cart-drawer__upsell-item');
                            
                            // If Slick didn't detect all slides, destroy and reinitialize
                            if (slickSlides.length !== originalSlides.length && originalSlides.length > 1) {
                                $0(carousel).slick('unslick');
                                // Show all slides again
                                originalSlides.forEach(function(slide) {
                                    slide.style.display = '';
                                });
                                // Wait a bit longer before reinitializing
                                setTimeout(function() {
                                    $0(carousel).slick(slickSettings);
                                    // Add class after reinitialization
                                    setTimeout(function() {
                                        if ($0(carousel).hasClass('slick-initialized')) {
                                            carousel.classList.add('slick-arrows-ready');
                                            truncateUpsellNames();
                                        }
                                    }, 100);
                                }, 200);
                            } else {
                                // All slides detected, add class to fade in arrows
                                carousel.classList.add('slick-arrows-ready');
                                // Truncate product names
                                truncateUpsellNames();
                            }
                        }
                    }, 400);
                });
            }
        } catch (err) {
            console.error('Failed to initialize upsell carousel', err);
        } finally {
            isInitializing = false;
        }
    }
    
    // Debounced version to prevent multiple rapid calls
    function debouncedInit(force = false) {
        if (initTimeout) {
            clearTimeout(initTimeout);
        }
        initTimeout = setTimeout(function() {
            initUpsellCarousel(force);
        }, 300);
    }
    
    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(initUpsellCarousel, 100);
        });
    } else {
        setTimeout(initUpsellCarousel, 100);
    }
    
    // Re-initialize when cart drawer opens (watches for 'active' class)
    let lastActiveState = false;
    let isObservingCartDrawer = false;
    const cartDrawerObserver = new MutationObserver(function(mutations) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            const isActive = cartDrawer.classList.contains('active');
            // When cart drawer opens, initialize
            if (isActive && !lastActiveState) {
                debouncedInit(true);
            }
            // When cart drawer closes, remove arrows-ready class to hide arrows
            if (!isActive && lastActiveState) {
                const carousel = document.querySelector('.cart-drawer__upsell-carousel');
                if (carousel) {
                    carousel.classList.remove('slick-arrows-ready');
                }
            }
            lastActiveState = isActive;
        }
    });
    
    // Watch for cart drawer class changes
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        lastActiveState = cartDrawer.classList.contains('active');
        cartDrawerObserver.observe(cartDrawer, {
            attributes: true,
            attributeFilter: ['class']
        });
        isObservingCartDrawer = true;
    }

    // Also watch for cart drawer being added to DOM
    const bodyObserver = new MutationObserver(function(mutations) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && !isObservingCartDrawer) {
            lastActiveState = cartDrawer.classList.contains('active');
            cartDrawerObserver.observe(cartDrawer, {
                attributes: true,
                attributeFilter: ['class']
            });
            isObservingCartDrawer = true;
        }
    });
    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Re-initialize after cart updates
    document.addEventListener('cart:refresh', function() {
        debouncedInit(true);
    });
    
    // Truncate names after cart updates
    document.addEventListener('cart:refresh', function() {
        setTimeout(truncateUpsellNames, 600);
    });
    
    // Handle "Add to Cart" from upsell widget
    document.addEventListener('submit', async function(e) {
        const form = e.target.closest('.cart-drawer__upsell-form');
        if (!form) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const button = form.querySelector('button[type="submit"]');
        const originalText = button.textContent;
        
        button.disabled = true;
        button.textContent = 'Adding...';
        
        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            });
            
            if (!res.ok) throw new Error(`Failed to add item: ${res.status}`);
            
            // Refresh cart drawer
            if (typeof window.__fwBundle?.refreshCartSections === 'function') {
                await window.__fwBundle.refreshCartSections();
            } else if (typeof fwRefreshCartUI === 'function') {
                await fwRefreshCartUI(true);
            } else {
                location.reload();
            }
        } catch (err) {
            console.error('Failed to add upsell item to cart', err);
            button.disabled = false;
            button.textContent = originalText;
            alert('Sorry, we couldn\'t add that item to your cart. Please try again.');
        }
    });
})();

/* 🔹 Freshwater — delete single (non-bundle) line by unique key */
document.addEventListener('click', async function (e) {
    const btn = e.target.closest('button.fw-remove-non-bundle');
    if (!btn) return;

    const row = btn.closest('.cart-item');
    const key = row?.dataset?.lineKey;
    const bundleId = row?.dataset?.bundleId || null;

    console.log(
        "🔹 %cFreshwater",
        "background:#e0e8ff; color:#2a52c9; font-weight:bold; padding:2px;",
        "fw-remove clicked",
        { key, bundleId }
    );

    if (!row || !key) return;

    /* skip bundles — handled elsewhere */
    if (bundleId) {
        console.log(
            "🔹 %cFreshwater",
            "background:#e0e8ff; color:#2a52c9; font-weight:bold; padding:2px;",
            "skipping: bundle row"
        );
        return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    /* disable button and show spinner while remove is in-flight */
    btn.disabled = true;
    const spinners = row.querySelectorAll('.loading__spinner');
    spinners.forEach(s => s.classList.remove('hidden'));

    try {
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: key, quantity: 0 })
        });

        console.log(
            "🔹 %cFreshwater",
            "background:#e0e8ff; color:#2a52c9; font-weight:bold; padding:2px;",
            "remove by key → ok?",
            res.ok
        );

        if (typeof window.__fwBundle?.refreshCartSections === 'function') {
            await window.__fwBundle.refreshCartSections();
        } else {
            await fwRefreshCartUI(false);
        }
    } catch (err) {
        console.error(
            "🔹 %cFreshwater",
            "background:#e0e8ff; color:#2a52c9; font-weight:bold; padding:2px;",
            "remove failed",
            err
        );
        location.reload();
    }
}, true);

/* 🔹 Freshwater — delete entire bundle (by Bundle ID → nuke all keys) */
document.addEventListener('click', async function (e) {
    const btn = e.target.closest('button.fw-bundle-remove');
    if (!btn) return;

    const host = btn.closest('[data-bundle-id]');
    const bundleId = host?.dataset?.bundleId;

    console.log(
        "🔹 %cFreshwater",
        "background-color: #e0e8ff; color: #2a52c9; font-weight: bold; margin-bottom: 2px; padding: 2px;",
        "fw-bundle-remove clicked",
        { bundleId }
    );

    if (!bundleId) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    try {
        const cart = await fetch('/cart.js', {
            headers: { 'Accept': 'application/json' }
        }).then(r => r.json());

        const keysToRemove = (cart.items || [])
            .filter(li => {
                const bid = (li.properties && (li.properties['Bundle ID'] || li.properties['bundle_id'])) || '';
                return String(bid) === String(bundleId);
            })
            .map(li => li.key);

        console.log(
            "🔹 %cFreshwater",
            "background-color: #e0e8ff; color: #2a52c9; font-weight: bold; margin-bottom: 2px; padding: 2px;",
            "keysToRemove",
            keysToRemove
        );

        if (!keysToRemove.length) return;

        const updates = {};
        keysToRemove.forEach(k => { updates[k] = 0; });

        const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
        });

        console.log(
            "🔹 %cFreshwater",
            "background-color: #e0e8ff; color: #2a52c9; font-weight: bold; margin-bottom: 2px; padding: 2px;",
            "bundle remove ok?",
            res.ok
        );

        if (typeof window.__fwBundle?.refreshCartSections === 'function') {
            window.__fwBundle.refreshCartSections();
        } else {
            location.reload();
        }
    } catch (err) {
        console.error(
            "🔹 %cFreshwater",
            "background-color: #e0e8ff; color: #2a52c9; font-weight: bold; margin-bottom: 2px; padding: 2px;",
            "bundle remove failed",
            err
        );
    }
}, true);
